import React from "react";
import "../Styles/MapsLocation.css";

const MapsLocation = ({
  iframeSrc,
  title = "Clinic Location",
  addressLabel = "Clinic Address",
  addressText = "Dhotrad's Sunny Dental Clinic",
  height = 450,
}) => {
  return (
    <div className="map-container">
      <div className="map-box">
        <iframe
          title={title}
          src={iframeSrc}
          width="100%"
          height={height}
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />

        <div className="address-card">
          <div className="icon-circle">📍</div>
          <div>
            <p className="label">{addressLabel}</p>
            <p className="address">{addressText}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MapsLocation;
